const naiveFormatShortCash = (n, maximumFractionDigits = 1) => {
    const formatOptions = {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits,
    };
    const absN = Math.abs(n);
    if (absN >= 1e3 && absN < 1e6) {
        return `${(n / 1e3).toLocaleString("en-US", formatOptions)}K`;
    }
    else if (absN >= 1e6 && absN < 1e9) {
        return `${(n / 1e6).toLocaleString("en-US", formatOptions)}M`;
    }
    else if (absN >= 1e9 && absN < 1e12) {
        return `${(n / 1e9).toLocaleString("en-US", formatOptions)}B`;
    }
    else if (absN >= 1e12) {
        return `${(n / 1e12).toLocaleString("en-US", formatOptions)}T`;
    }
    else {
        return n.toLocaleString("en-US", formatOptions);
    }
};
export const formatShortCash = (n, maximumFractionDigits = 1) => {
    const str = naiveFormatShortCash(n, maximumFractionDigits);
    if (maximumFractionDigits === 0) {
        return str;
    }
    // 999,999,999 => is $1B and not 1,000M so bump the amount up
    if (str.includes(",") && !str.includes("T")) {
        return formatShortCash(n + Math.pow(10, -1 * (maximumFractionDigits + 2)) * n, maximumFractionDigits);
    }
    return str;
};
export const formatCurrency = (str, options = { style: "currency", currency: "USD" }) => {
    const n = Number(str.replace(/[^0-9.-]+/g, ""));
    return n.toLocaleString("en-US", options);
};
export const formatCurrencyTextField = (options) => (setValue) => (prevValue) => (newValue) => {
    // If we are deleting we have special rules
    if (newValue.length < prevValue.length) {
        // We are deleting from the back
        if (prevValue.slice(0, -1) === newValue) {
            // Only currency format or empty string is left over, we do not apply new formatting
            if (newValue.replace(/[^0-9.]+/g, "") === "") {
                setValue(newValue);
                return;
            }
            // if we are deleting cents, we do not apply new formatting
            if (newValue.includes(".") || // if we are deleting cents, we do not apply new formatting
                (prevValue.includes(".") && !newValue.includes(".")) // we are deleting the decimal point, we do not apply new formatting
            ) {
                setValue(newValue);
                return;
            }
            else {
                setValue(formatCurrency(newValue, options));
                return;
            }
        }
    }
    //do not format on a weird value
    if (/^\$?[\d,]+(\.\d+)?$/.test(newValue) === false) {
        setValue(newValue);
        return;
    }
    setValue(formatCurrency(newValue, options));
    return;
};
//# sourceMappingURL=numbers.js.map